import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Gen3Features } from '../components/Gen3Features';
import { CategoriesSection } from '../components/CategoriesSection';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { AlphabeticalIndex } from '../components/AlphabeticalIndex';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-851">
      <Header data-id="element-852" />

      <main className="flex-grow" data-id="element-853">
        <Hero data-id="element-854" />
        <FeaturedProducts data-id="element-855" />
        <CategoriesSection data-id="element-856" />
        <Gen3Features data-id="element-857" />
        <AlphabeticalIndex data-id="element-858" />
      </main>

      <Footer data-id="element-859" />
    </div>;
}